export enum RoleEnum {
  ADMIN = 'ADMIN',
  USER = 'USER',
  PERSONAL = 'PERSONAL',
  REVIEWER = 'REVIEWER',
}
